export const ALL_PRODUCTS = 'ALL_PRODUCTS';
export const ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS';
export const ALL_PRODUCTS_FAILURE = 'ALL_PRODUCTS_FAILURE';

export const PRODUCT_BY_ID = 'PRODUCT_BY_ID';
export const PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS';

export const ADD_PRODUCT = 'ADD_PRODUCT';
export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS';
export const ADD_PRODUCT_FAILURE = 'ADD_PRODUCT_FAILURE';

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';

export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const REMOVE_PRODUCT_SUCCESS = 'REMOVE_PRODUCT_SUCCESS';
export const REMOVE_PRODUCT_FAILURE = 'REMOVE_PRODUCT_FAILURE';

export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';

export const ALL_MANUFACTURERS = 'ALL_MANUFACTURER';
export const ALL_MANUFACTURERS_SUCCESS = 'ALL_MANUFACTURER_SUCCESS';

export const REGISTRATION = 'REGISTRATION';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';

export const  DELETE_PRODUCT = 'DELETE_PRODUCT';
export const  DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';

export const  LOGIN = 'LOGIN';
export const  LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const  LOGIN_ERROR = 'LOGIN_ERROR';
export const  LOGOUT = 'LOGOUT';
export const  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const  LOGOUT_FAILED = 'LOGOUT_FAILED';


export const  ALL_USERS = 'ALL_USERS';
export const  ALL_USERS_SUCCESS = 'ALL_USERS_SUCCESS';

export const  ADD_USER = 'ADD_USER';
export const  ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';

export const  USER_BY_ID = 'USER_BY_ID';
export const  USER_BY_ID_SUCCESS = 'USER_BY_ID_SUCCESS';

export const  DELETE_USER = 'DELETE_USER';
export const  DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';


export const  SEND_MESSAGE = 'SEND_MESSAGE';
export const  SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const  SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';

export const  GET_MESSAGE = 'GET_MESSAGE';
export const  GET_MESSAGE_SUCCESS = 'GET_MESSAGE_SUCCESS';
export const  GET_MESSAGE_FAILURE = 'GET_MESSAGE_FAILURE';

export const  USER_PROFILE = 'USER_PROFILE';
export const  USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const  USER_PROFILE_FAILURE = 'USER_PROFILE_FAILURE';

export const  UPDATE_PROFILE = 'UPDATE_PROFILE';
export const  UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const  UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';










